import React from 'react'
import * as Fields from 'support/fields'
import {
  ModelWithForm
} from '@morningtrain/react-resources'
import Button from 'ui/buttons/Button'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Translation } from '@morningtrain/react-translations'
import * as UI from 'ui'
import Fieldset from 'layouts/form/Fieldset'
import RedirectToEditOnCreatePipeline from 'support/pipelines/RedirectToEditOnCreatePipeline'
import { WhenRouteHasParameter } from '@morningtrain/react-navigation'

export default function InventoryEditForm () {
  const resourceName = 'inventory.category'

  return (
    <ModelWithForm resourceName={resourceName}>
      <UI.PageHeader title={(
        <>
          <WhenRouteHasParameter name='inventory_category'>
            <TranslatedTitle name='titles.edit' />
          </WhenRouteHasParameter>
          <WhenRouteHasParameter name='inventory_category' negate>
            <TranslatedTitle name='titles.create' />
          </WhenRouteHasParameter>
        </>
      )}
      >
        <div className='flex space-x-4'>
          <Button text={<Translation name='generic.save' />} type='submit' />
        </div>
      </UI.PageHeader>
      <UI.CardGroup>
        <UI.Card>
          <Fieldset cols={2}>
            <Fields.Input name='name_translations.en' label={<Translation name='fields.name_translations.en.label' />} />
            <Fields.Input name='name_translations.da' label={<Translation name='fields.name_translations.da.label' />} />
            <Fields.Select name='status' enum='active_status' label={<Translation name='fields.status.label'/>}/>
          </Fieldset>
        </UI.Card>
      </UI.CardGroup>

      <RedirectToEditOnCreatePipeline routeName='app.settings.inventory.edit' />
    </ModelWithForm>
  )
}
